/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// require('./bootstrap');

// window.Vue = require('vue').default;
window._ = require('lodash')

import axios from './axios'
window.axios = axios

import qs from 'qs'
window.qs = qs

import moment from './moment'
window.moment = moment

import numeral from './numeral'
window.numeral = numeral

import '@fortawesome/fontawesome-free/css/all.css'
import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import { Inertia } from '@inertiajs/inertia'
import { createInertiaApp } from '@inertiajs/inertia-vue'
import { InertiaProgress } from '@inertiajs/progress'
import Vuetify from 'vuetify'
import { VExpansionPanels } from 'vuetify/lib'
// import VueRouter from 'vue-router'
import Vuex from 'vuex'
import DatePicker from 'vue2-datepicker'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import VueSafeHTML from 'vue-safe-html'
import VueScrollTo from 'vue-scrollto'
import light from './theme'
import store from './stores'
import globalMixin from './mixins/global'
import LayoutDashboard from './layouts/Dashboard'

import Alert from '@components/Alert'
import FileUploader from '@components/FileUploader'

InertiaProgress.init({
  showSpinner: true,
  color: '#FFB300',
})
Vue.prototype.$route = route
Vue.prototype.$axios = axios
Vue.prototype.$moment = moment
Vue.use(Vuex)

Vue.use(Vuetify)
Vue.use(VueSafeHTML)
Vue.use(VueScrollTo)
Vue.mixin(globalMixin)

Vue.component('VExpansionPanels', VExpansionPanels)
Vue.component('DatePicker', DatePicker)
Vue.component('TimePicker', VueTimepicker)
Vue.component('Alert', Alert)
Vue.component('FileUploader', FileUploader)

createInertiaApp({
  resolve: (name) => {
    const page = require(`./pages/${name}`).default
    page.layout = page.layout || LayoutDashboard
    return page
  },
  title: (title) => `${title} | XuYuan Class`,
  setup({ el, App, props }) {
    new Vue({
      store,
      vuetify: new Vuetify({
        theme: {
          dark: false,
          themes: {
            light,
          },
        },
        icons: {
          iconfont: 'mdi',
        },
      }),
      render: (h) => h(App, props),
    }).$mount(el)
  },
})

Inertia.on('navigate', (event) => {
  gtag('event', 'page_view', {
    page_location: event.detail.page.url,
  })
})
